import React from "react";

import Sheldon from "@common/assets/images/ai/sheldon.png";
import { FilterButton } from "@main/pages/shared/components/ActivityHistoryTable/SearchAndFilter/FilterButton";
import { NetworkFilter } from "@main/pages/shared/components/ActivityHistoryTable/SearchAndFilter/NetworkFilter";
import { SearchInput } from "@main/pages/shared/components/ActivityHistoryTable/SearchAndFilter/SearchInput";
import { ActivityHistoryFilter } from "@main/pages/shared/consumers/useActivityHistoryFilter";
import {
  ConsoleLogsFilterIcon,
  CustomLogsFilterIcon,
  NotificationEventsFilterIcon,
  ScreenViewsFilterIcon,
  SystemEventsFilterIcon,
  UserActionsFilterIcon,
} from "@main/pages/shared/icons/icons";

import * as Styled from "./ActivityHistoryFilter.styles";

const filterButtonConfigs: {
  key: keyof Pick<
    ActivityHistoryFilter,
    "consoleLogs" | "systemEvents" | "customLogs" | "screenViews" | "userActions" | "notificationEvents" | "ai"
  >;
  title: string;
  icon: React.ReactNode;
}[] = [
  { key: "consoleLogs", title: "Console logs", icon: <ConsoleLogsFilterIcon /> },
  { key: "systemEvents", title: "System events", icon: <SystemEventsFilterIcon /> },
  { key: "userActions", title: "User actions", icon: <UserActionsFilterIcon /> },
  { key: "screenViews", title: "Screen views", icon: <ScreenViewsFilterIcon /> },
  { key: "notificationEvents", title: "Notification events", icon: <NotificationEventsFilterIcon /> },
  { key: "customLogs", title: "Custom logs", icon: <CustomLogsFilterIcon /> },
];

interface ActivityHistoryFilterProps {
  filter: ActivityHistoryFilter;
  setFilter: (filter: ActivityHistoryFilter) => void;
  showSheldonButton: boolean;
}

const ActivityHistoryFilterView = ({ filter, setFilter, showSheldonButton }: ActivityHistoryFilterProps) => {
  const handleToggle = (key: keyof ActivityHistoryFilter) => {
    setFilter({ ...filter, [key]: !filter[key] });
  };

  const newFilterButtonConfigs = [...filterButtonConfigs];
  if (showSheldonButton) {
    newFilterButtonConfigs.push({
      key: "ai" as const,
      title: "AI Summary",
      icon: (
        <img
          src={Sheldon}
          style={{ height: "3rem", width: "3rem" }}
        />
      ),
    });
  }

  return (
    <Styled.ActivityHistoryFilter>
      <SearchInput
        value={filter.searchText}
        onChanged={(text) => setFilter({ ...filter, searchText: text })}
      />
      <NetworkFilter
        setFilter={setFilter}
        filter={filter}
      />
      {newFilterButtonConfigs.map(({ key, title, icon }) => (
        <FilterButton
          key={key}
          title={title}
          isActive={filter[key]}
          ai={key === "ai"}
          onClick={() => handleToggle(key)}
          icon={icon}
        />
      ))}
    </Styled.ActivityHistoryFilter>
  );
};

export { ActivityHistoryFilterView };
